import React, { Component } from 'react';
import './App.css';
import HomeView from './views/home/HomeView';
import ScanView from './views/scan/ScanView';
// import LoginView from './views/login/LoginView';
import HowtoView from './views/howto/HowtoView';
import SharePageSoup from "./views/sharePage/SharePageSoup";
import { connect } from "react-redux";
import { VIEW_STATE } from '../util/constConfig';
import { updateViewState, toggleSharePanel, closeRichModal } from "../actions/index";
import { getParameterByName } from "../util/queryUtil";
import { showRichModal } from "../actions";
import { updateJSSDK } from "../util/wxUtil";
import { getStaticHost } from "../util/serverUtil";

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            viewState : VIEW_STATE.HOME

        };


        this.onUserClick = this.onUserClick.bind(this);
        this.closeSharePanel = this.closeSharePanel.bind(this);

        this.onShareCancel = this.onShareCancel.bind(this);
        this.onShareAppOK = this.onShareAppOK.bind(this);
        this.onShareTimelineOK = this.onShareTimelineOK.bind(this);
        this.onShareQQOK = this.onShareQQOK.bind(this);
        this.onShareWeiboOK = this.onShareWeiboOK.bind(this);
    }

    componentDidMount() {

        if (this.props.isAuthenticated) {

        }

        const link = encodeURI(getStaticHost() + "/?share=wish&filename=" + this.props.currentWorkName);
        const imgUrl = getStaticHost() + '/logoL31.png';
        const title = 'K11沈阳咚咚仔⻢戏团开演啦!';
        const desc = '快来获取你⾃己创作的填⾊作品，⻢上开始吧～';
        const app = this.onShareAppOK;
        const time = this.onShareTimelineOK;
        const weibo = this.onShareWeiboOK;
        const qq = this.onShareQQOK;
        const cancel = this.onShareCancel;
        setTimeout( ()=> {
            updateJSSDK(//linkUrl, imgUrl, title, desc, app, time, weibo, qq, cancelCB
                link, imgUrl, title, desc, app, time, weibo, qq, cancel
            );

            // console.log('vio shareData', this.makeVioSatisfy());

        }, 800);

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentWorkName !== prevProps.currentWorkName && this.props.currentWorkName.length > 0) {
            const link = encodeURI(getStaticHost() + "/?share=wish&filename=" + this.props.currentWorkName);
            const imgUrl = getStaticHost() + '/logo28.png';
            const title = 'K11沈阳咚咚仔⻢戏团开演啦!';
            const desc = '快来获取你⾃己创作的填⾊作品，⻢上开始吧～';
            const app = this.onShareAppOK;
            const time = this.onShareTimelineOK;
            const weibo = this.onShareWeiboOK;
            const qq = this.onShareQQOK;
            const cancel = this.onShareCancel;
            setTimeout( ()=> {
                updateJSSDK(//linkUrl, imgUrl, title, desc, app, time, weibo, qq, cancelCB
                    link, imgUrl, title, desc, app, time, weibo, qq, cancel
                );

                // console.log('vio shareData', this.makeVioSatisfy());

            }, 800);
        }


    }



    onUserClick() {
        console.log('onUserClick');
        this.props.updateViewState(VIEW_STATE.USER_CENTER);
    }

    closeSharePanel() {
        console.log('closeSharePanel');
        this.props.toggleSharePanel(false);
    }


    onShareCancel() {
        //console.log('onShareCancel');
        // alert('onShareCancel');
    }

    onShareAppOK() {
        console.log('onShareAppOK');

        // this.setState({
        //     ...this.state,
        //     shareSuccess:true
        // });
        // alert('onShareAppOK');
        // this.props.onShareOK();

        //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
        // console.log('_vio.push(["_share","talk" .....');
        // window._vio.push(["_share","talk", this.makeVioSatisfy()]);
        // window.mixpanel.track("share", {
        //     'name': 'talk'
        // });
    }

    onShareTimelineOK() {
        console.log('onShareTimelineOK');

        // this.setState({
        //     ...this.state,
        //     shareSuccess:true
        // });

        // alert('onShareTimelineOK');
        //   this.props.onShareOK();
        //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
        // console.log('_vio.push(["_share","wechat" .....');
        // window._vio.push(["_share","wechat", this.makeVioSatisfy()]);
        // window.mixpanel.track("share", {
        //     'name': 'wechat'
        // });
    }

    onShareWeiboOK() {
        console.log('onShareWeiboOK');

        // this.setState({
        //     ...this.state,
        //     shareSuccess:true
        // });
        // alert('onShareTimelineOK');
        //  this.props.onShareOK();
        //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
        // console.log('window._vio.push(["_share","weibo" .....');
        // window._vio.push(["_share","weibo", this.makeVioSatisfy()]);
        window.mixpanel.track("share", {
            'name': 'weibo'
        });
    }

    onShareQQOK() {
        console.log('onShareQQOK');

        // this.setState({
        //     ...this.state,
        //     shareSuccess:true
        // });
        // alert('onShareWeiboOK');
        //  this.props.onShareOK();
        //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
        // console.log('window._vio.push(["_share","qq" .....');
        // window._vio.push(["_share","qq", this.makeVioSatisfy()]);
        // window.mixpanel.track("share", {
        //     'name': 'qq'
        // });
    }


    render() {
        const share = getParameterByName('share');
        if (share === 'wish') {
            return (<SharePageSoup/>);
        }

        return (
            this.props.isAuthenticated||1 ?
                <div className="App">
                    {/*首页*/}
                    {(this.props.viewState === VIEW_STATE.HOME)
                    && <HomeView/>}

                    {/*Scan*/}
                    {(this.props.viewState === VIEW_STATE.SCAN)
                    && <ScanView/>}

                    {(this.props.viewState === VIEW_STATE.SHARE)
                    && <SharePageSoup/>}

                    {(this.props.viewState === VIEW_STATE.HOWTO)
                    && <HowtoView/>}

                    {/*分享*/}
                    {this.props.showShare &&
                    <div className="App-share"  onClick={this.closeSharePanel}>
                        {/*<img alt="" src={shareImg} onClick={this.closeSharePanel}/>*/}
                        <i alt="" className="fa fa-level-up-alt app-level"/>
                        <p>点此分享</p>
                    </div>}

                    {/*Modal*/}
                    {this.props.richModalReducer.modal &&
                    <div className="App-Modal">
                        <div className="App-Modal-c">
                            <p>{this.props.richModalReducer.title}</p>
                            <p>{this.props.richModalReducer.content}</p>
                            <button onClick={() => {
                                this.props.closeRichModal()
                            }}>知道了
                            </button>
                        </div>
                    </div>}

                </div>

                : <div></div>
        );

    }
}

export default connect(state => ({
        isAuthenticated: state.loginReducer.isAuthenticated,
        viewState: state.viewStateReducer.viewState,
        showShare: state.viewStateReducer.showShare,
        richModalReducer: state.richModalReducer,
        currentWorkName: state.workReducer.currentWorkName
        // richModalReducer2: state.richModalReducer2
    }),
    dispatch => ({
        updateViewState: (sceneData) => {
            dispatch(updateViewState(sceneData))
        },
        toggleSharePanel: (visible) => {
            dispatch(toggleSharePanel(visible))
        },
        closeRichModal: () => {
            dispatch(closeRichModal())
        },
        // login: (sceneData) => {
        //     dispatch(login(sceneData))
        // },
        // showTimeModal: (data) => {
        //     dispatch(showTimeModal(data))
        // },
        showRichModal: data => {
            dispatch(showRichModal(data))
        },
    }))(App)



// WEBPACK FOOTER //
// ./src/react/App.js